import { setWrapperWidth, showCurrentPostNum } from './owl-carousel';

var $ = jQuery;

$(document).ready(function(){

    if ( $(".recommended-courses-mobile .recommended-courses").length > 0 && $( window ).width() < 768 ) {

        $(".recommended-courses-mobile .recommended-courses .owl-carousel").owlCarousel({
            dots: true,
            loop: true,
            nav: false,
            items: 1,
            margin: 14,
            autoWidth: true,
        });

        setWrapperWidth( '.recommended-courses-mobile .recommended-courses .kb-main-wrapper' );
    }

    if ( $("#courses-list").length > 0 && $( window ).width() < 768 ) {

        initializeKsefOwlCarousel();
    }

});

export const initializeKsefOwlCarousel = () => {

    if ( $(" #courses-list .owl-carousel > * ").length > 1 ) {

        $("#courses-list .owl-carousel").owlCarousel({
            dots: true,
            loop: true,
            nav: false,
            items: 1,
            margin: 14,
            autoWidth: true,
            onInitialized: coursesListCallback,
            onResized: coursesListCallback,
            onTranslated: coursesListCallback,
        });

    } else {

        $("#courses-list .owl-carousel").owlCarousel({
            dots: true,
            loop: false,
            nav: false,
            items: 1,
            margin: 0,
            autoWidth: true,
        });
    }

    setWrapperWidth( '#courses-list .kb-main-wrapper' );
}

const coursesListCallback = () => {
    showCurrentPostNum( '#courses-list .post-num', '#courses-list .owl-stage .owl-item:not(.cloned)' );
}
